import React, { useEffect } from "react";
import styles from "./FailPage.module.scss";
import useSectionDimensions from "@/hooks/useSectionDimensions";
import { ExclamationSvg } from "@/assets/icons";
import { FTFlex, Mask } from "@/components";
import { useCommonStore } from "@/stores";
import { useTranslation } from "react-i18next";
import useEffectStore from "@/stores/effectStore";
import { withPublicPath } from "@/utils";

export default function FailPage() {
  const { t } = useTranslation();
  const fileOptions = useEffectStore((state) => state.fileOptions);
  const [size, setSize] = React.useState({
    width: fileOptions.width || 1,
    height: fileOptions.height || 1,
  });
  const errorCode = useEffectStore((state) => state.errorCode);
  const errorMsg = useEffectStore((state) => state.errorMsg);
  // const errorDesc = useEffectStore((state) => state.errorDesc);
  const retryGenerate = useEffectStore((state) => state.retryGenerate);
  const {
    width: imgWidth,
    height: imgHeight,
    imgEleRef,
    syncDimensions,
  } = useSectionDimensions();
  // const minSlider = Math.min(imgWidth - 96, imgHeight - 96);
  useEffect(() => {
    syncDimensions();
  }, []);

  const handleRetry = () => {
    retryGenerate();
  };
  return (
    <FTFlex
      className={styles.loading_wrapper}
      gap={64}
      direction="column"
      align="center"
      justify="center"
      ref={imgEleRef}
    >
      <div
        className={styles.loading}
        style={{ aspectRatio: `${size.width / size.height}` }}
        // style={{ width: minSlider, height: minSlider }}
      >
        <div
          className={styles.loading_img}
          style={{ aspectRatio: `${size.width / size.height}` }}
        >
          <Mask
            url={
              fileOptions?.uploadFile?.blobUrl ?? fileOptions.uploadFile?.url
            }
          />
          <div className={styles.loading_img_inner}>
            <span className={styles.icon}>
              <ExclamationSvg />
            </span>
            <span className={styles.text}>
              {t(errorMsg || "error_result_common_title")}
            </span>
            {/* <span className={styles.desc}>
              {t(errorDesc || "error_result_common_desc")}
            </span> */}
            <div className={styles.retry} onClick={handleRetry}>
              {t("retry")}
            </div>
          </div>
        </div>
      </div>
    </FTFlex>
  );
}
